// extracted by mini-css-extract-plugin
module.exports = {"container":"Action_container__sOtYq","icon":"Action_icon__XqoOw","text":"Action_text__DrxcQ"};